import {copilotFeatureFlags} from '@github-ui/copilot-chat/utils/copilot-feature-flags'
import {useAgentModels} from './useAgentModels'
import {trimModelName} from '../utils/trim-model-name'

export function useSelectedModel(modelId: string | undefined) {
  const {models: agentModels} = useAgentModels()
  const availableModels = copilotFeatureFlags.codingAgentModelSelection ? agentModels : undefined

  if (!modelId || !availableModels) return undefined

  return availableModels.find(m => m.id === trimModelName(modelId))
}
